import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.34 5.152L12 3 9.66 5.152 6.439 4.72l-.563 3.049L3 9.218 4.43 12 3 14.781l2.875 1.451.563 3.05 3.223-.434L12 21l2.34-2.152 3.222.433.563-3.049L21 14.782 19.57 12 21 9.219l-2.875-1.451-.563-3.05-3.223.434z"
      fill="currentColor"
    />
    <path
      d="M12.724 15.6c1.544 0 2.57-1.048 2.57-2.214 0-1.296-1.242-1.782-1.242-1.782s.864-.486.864-1.566c0-1.026-.972-1.998-2.376-1.998H9.3v7.56h3.424zm-1.804-1.35v-1.944h1.728c.594 0 1.026.432 1.026.972s-.432.972-1.026.972H10.92zm1.512-4.86c.54 0 .864.324.864.81 0 .486-.324.81-.864.81H10.92V9.39h1.512z"
      fill="#fff"
    />
  </svg>
);
